import React from 'react';
import StoryCard from './share/StoryCard';

/** A Portal as a 1080×1920 story: the person's words, in Times italic, are the hero. */
export default function SignalStoryCard({ accent = '#22ECFB', init = 'R', topline = '', keyword = 'OPENED A PORTAL', words = '', meta = '', closer = 'COME FIND ME →', template = 'ring', image = null, format = 'story', refEl }) {
  return (
    <StoryCard
      template={template} format={format} image={image} fallback="swirl" accent={accent}
      status="LIVE NOW" statusBg="#22ECFB" init={init} topline={topline} keyword={keyword}
      words={words} serif meta={meta} cta={closer} refEl={refEl}
    />
  );
}
